import React, { useState, useContext } from 'react'
import { FileUploader } from 'react-drag-drop-files'
import { UserContext } from '../Context/User'
import { StoresContext } from '../Context/Stores'
import Error from './Error'
import Instructions from './Instructions'
import DropZone from './DropZone'
import YesOrNo from '../YesOrNo'

const FILE_TYPES = ['CSV']

function useFileDragDrop({ method }) {
  const user = useContext(UserContext)
  const storesCtx = useContext(StoresContext)
  const { channel } = storesCtx

  const fileRef = React.useRef()
  const [file, setFile] = useState(null)
  const [error, setError] = useState(null)

  const [showYesOrNo, setShowYesOrNo] = useState(false)
  const confirmImport = (file) => {
    fileRef.current = file
    setShowYesOrNo(true)
  }

  const doImport = () => {
    setShowYesOrNo(false)
    if (user.authenticated) {
      setFile(fileRef.current)
    }
  }

  const reset = () => {
    setError(null)
    setFile(null)
    user[method] = {}
  }

  const onTypeError = (err) => {
    setError(err)
  }

  const FileSelector = ({ disabled, launched = true }) => (
    <div className="flex flex-col flex-1">
      {!launched && <Error msg="Import not supported yet - COMING SOON" />}
      {launched && error && <Error msg="Only CSV files accepted for import" />}
      {launched && !error && <Instructions />}

      <FileUploader
        handleChange={confirmImport}
        name="file"
        types={FILE_TYPES}
        onTypeError={onTypeError}
        disabled={disabled}
        hoverTitle=" "
        classes={`flex-1 flex flex-col ${!launched ? 'opacity-10' : ''}`}
      >
        <DropZone disabled={disabled} />
      </FileUploader>
      {showYesOrNo && (
        <YesOrNo
          title={`${channel.name}`}
          message={`Are you sure you want to import this CSV file to your ${channel.name} storefront? Did you save a copy of the file before making changes?`}
          doYes={doImport}
          showMe={setShowYesOrNo}
        />
      )}
    </div>
  )

  return {
    file,
    FileSelector,
    reset,
  }
}

export default useFileDragDrop
